import { EntityIcon, EntityIconProps } from '@ardoq/basic-components';
import { DecoratorWrapper, getDecoratorIconSize } from './atoms';
import { TextOverflow } from '@ardoq/popovers';

type EntityDecoratorProps = {
  label?: string;
} & EntityIconProps;

export const EntityDecorator = ({
  label,
  ...entityIconProps
}: EntityDecoratorProps) => (
  <DecoratorWrapper $skipIconColor>
    <EntityIcon iconSize={getDecoratorIconSize()} {...entityIconProps} />
    <TextOverflow renderIn="tooltip">{label}</TextOverflow>
  </DecoratorWrapper>
);
